import { useState } from "react";


export default function useToken() {
    let tokenItem = sessionStorage.getItem('token')

    const [token, SetToken] = useState(tokenItem === null ? undefined : tokenItem);

    const saveToken = userToken => {
        sessionStorage.setItem('token', userToken);
        SetToken(userToken);
    }

    return {setToken: saveToken,
            token}
}